import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const accountInfoRequest = createRequest(constants.accountInfo);
export const accountInfoSuccess = createSuccess(constants.accountInfo);
export const accountInfoFailure = createFailure(constants.accountInfo);

export const requestAccountInfo = accountInfoRequest;
